const hebrewStrings = {
  second: {
    many: "שניות",
    single: "שניה אחת",
    time: 1000,
  },
  minute: {
    many: "דקות",
    single: "דקה אחת",
    time: 1000 * 60,
  },
  hour: {
    many: "שעות",
    single: "שעה אחת",
    time: 1000 * 60 * 60,
  },
  day: {
    many: "ימים",
    single: "יום אחד",
    time: 1000 * 60 * 60 * 24,
  },
  week: {
    many: "שבועות",
    single: "שבוע אחד",
    time: 1000 * 60 * 60 * 24 * 7,
  },
  month: {
    many: "חודשים",
    single: "חודש אחד",
    time: 1000 * 60 * 60 * 24 * 30,
  },
  year: {
    many: "שנים",
    single: "שנה אחת",
    time: 1000 * 60 * 60 * 24 * 365,
  },
} as const;

export function milisToText(milis: number) {
  let ret = "";
  for (const val of Object.values(hebrewStrings).sort(
    (a, b) => b.time - a.time,
  )) {
    const { many, single, time } = val;
    const match = Math.floor(milis / time);

    let str = "";
    if (match === 1) str = single;
    else if (match > 1) str = `${match} ${many}`;
    if (ret === "") ret = str;
    else if (str) ret += ` ו${str}`;
    milis = milis % time;
  }
  return ret || hebrewStrings.second.single;
}
